var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.model.headerClasses,
      style: { height: _vm.model.renderedHeight },
    },
    [
      !!_vm.model.backgroundImage
        ? _c("div", {
            class: _vm.model.backgroundImageClasses,
            style: _vm.model.backgroundImageStyle,
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.survey.isMobile
        ? _c(
            "div",
            {
              class: _vm.model.contentClasses,
              style: { maxWidth: _vm.model.maxWidth },
            },
            _vm._l(_vm.model.cells, function (cell, index) {
              return _c("sv-header-cell", {
                key: index,
                attrs: { model: cell },
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.survey.isMobile
        ? _c(
            "div",
            [_c("sv-header-mobile", { attrs: { model: _vm.model } })],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }